const darkBlue = {
  100: '#34495E'
};

export { darkBlue };
